module.exports = __webpack_public_path__ + "static/media/faq_3.4f394714.svg";